// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { MobileAppFlavorConfigAreaId } from './MobileAppFlavorConfigAreaId'
import { MobileAppFlavorConfigAreaNavigation } from './MobileAppFlavorConfigAreaNavigation'
import { MobileAppFlavorConfigAreaRoutes } from './MobileAppFlavorConfigAreaRoutes'

const LazyMobileAppFlavorConfigComponent = lazy(
  () => import('./MobileAppFlavorConfigArea'),
)

const MobileAppFlavorConfigComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyMobileAppFlavorConfigComponent />
  </SuspenseLoadingWrapper>
)

export const MobileAppFlavorConfigArea = {
  id: MobileAppFlavorConfigAreaId,
  requiredRight: BoumRight.AREA_APP_FLAVOR_CONFIG,
  NavigationComponent: MobileAppFlavorConfigAreaNavigation,
  route: {
    path: MobileAppFlavorConfigAreaRoutes.route,
    component: MobileAppFlavorConfigComponent,
  },
}
